Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK_VERSION = '6.19.7';
//# sourceMappingURL=version.js.map